import { render, staticRenderFns } from "./ForgotPasswordOptions.vue?vue&type=template&id=92fd1b94&scoped=true&"
import script from "./ForgotPasswordOptions.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordOptions.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordOptions.vue?vue&type=style&index=0&id=92fd1b94&prod&lang=css&"
import style1 from "./ForgotPasswordOptions.vue?vue&type=style&index=1&id=92fd1b94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fd1b94",
  null
  
)

export default component.exports